import React from "react";
import useVencimentoCountdown from "../hooks/useVencimentoCountdown";

const pad = (valor) => String(valor).padStart(2, "0");

const VencimentoCountdown = ({ alvo, variant = "inline", className = "", label = "Tempo restante" }) => {
  const { horas, minutos, segundos, expirado } = useVencimentoCountdown(alvo);

  if (!alvo) return null;

  const urgente = !expirado && horas < 3;

  return (
    <span
      className={[
        "vencimento-countdown",
        `vencimento-countdown--${variant}`,
        expirado ? "vencimento-countdown--expirado" : "",
        urgente ? "vencimento-countdown--urgente" : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      role="timer"
      aria-live="polite"
      aria-label={`${label}: ${pad(horas)} horas, ${pad(minutos)} minutos e ${pad(segundos)} segundos`}
    >
      {variant !== "chip" && variant !== "inline" && (
        <span className="vencimento-countdown__label">{label}</span>
      )}
      <span className="vencimento-countdown__digits">
        <span className="vencimento-countdown__part">
          <strong>{pad(horas)}</strong>
          <small>h</small>
        </span>
        <span className="vencimento-countdown__sep" aria-hidden="true">
          :
        </span>
        <span className="vencimento-countdown__part">
          <strong>{pad(minutos)}</strong>
          <small>min</small>
        </span>
        <span className="vencimento-countdown__sep" aria-hidden="true">
          :
        </span>
        <span className="vencimento-countdown__part vencimento-countdown__part--sec">
          <strong>{pad(segundos)}</strong>
          <small>seg</small>
        </span>
      </span>
    </span>
  );
};

export default VencimentoCountdown;
